function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#000000",
  d: "M193.8,28.8h-36.6v20H182c5.8,0,13.2,4,13.2,6.3v158.2v1.3v2.3c0,5-7.4,9-13.2,9h-79.2H92.7H71.3c-5.8,0-10.5-4-10.5-9V57.8c0-5,4.7-9,10.5-9h29.6v-20H62.2c-6.7,0-20.9,8.3-20.9,18.4v180.5c0,13.3,14.1,18.3,20.9,18.3h21.1H119h74.8c6.7,0,20.9-2.7,20.9-18.3v-21.4v-4.5V47.2C214.7,37.9,200.6,28.8,193.8,28.8z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M82.4,124.7h32.8v4.6H82.4V124.7L82.4,124.7z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M82.4,108.8h32.8v4.6H82.4V108.8z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M82.4,140.6h92.3v4.6H82.4V140.6L82.4,140.6z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M82.4,156.9h92.3v4.6H82.4V156.9L82.4,156.9z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M82.4,173.1h92.3v4.6H82.4V173.1L82.4,173.1z"
}), React.createElement("path", {
  fill: "#000000",
  d: "M77.6,60.3v17.5h102V60.3c0-2.8-2.3-5.1-5.1-5.1H151V26.6c0-9.2-10.1-16.6-19.3-16.6h-4.7c-9.2,0-19.3,7.4-19.3,16.6v28.6H82.7C79.9,55.2,77.6,57.5,77.6,60.3z M128.6,28.4c5.7,0,10.3,4.6,10.3,10.3c0,5.7-4.6,10.3-10.3,10.3s-10.3-4.6-10.3-10.3C118.3,33,122.9,28.4,128.6,28.4z"
})));

var SvgOrder = function SvgOrder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Order.d58ac9f6.svg";
export { ForwardRef as ReactComponent };